import Skeleton from "react-loading-skeleton";

import styles from "./styles.module.scss";

export function DashboardCardSkeleton() {
  return (
    <div className={styles.container}>
      <Skeleton width={"100%"} height={"8.25rem"} count={3} />
    </div>
  );
}
